import React, {useState} from "react";
import {Button, Drawer} from "antd";
import {Link} from "react-router-dom";
import {MenuFoldOutlined} from "@ant-design/icons";

import config from '@/config'

const DrawerMB = () => {
    const [open, setOpen] = useState(false);
    const [isLoggedIn , setIsLoggedIn] = useState(true);

    const showDrawer = () => {
        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };

    const liItems = [
        {
            title: "Trang chủ",
            src: config.routes.home,
        },
        {
            title: "Việc làm",
            src: config.routes.job,
        },
        {
            title: "Công ty",
            src: config.routes.company,
        },
        {
            title: "Ứng tuyển",
            src: config.routes.cv,
        },
        {
            title: "Tin mới",
            src: config.routes.news,
        },
        {
            title: "Đăng nhập",
            src: config.routes.login,
        },
        {
            title: "Đăng ký ứng viên",
            src: config.routes.registerCandidate,
        },
        {
            title: "Đăng ký nhà tuyển dụng",
            src: config.routes.registerEmployer,
        },
        {
            title: "Tạo hồ sơ ứng tuyển",
            src: config.routes.resume,
        },
        {
            title: "Tạo không gian tuyển dụng",
            src: config.routes.createApplyLists,
        },
    ]
    const MenuHeader = (
        <div className={"justify-between flex items-center"}>
            <Link to={config.routes.home} onClick={onClose}>
                <img className={"w-24 h-full"} src={config.webConfig.logo} alt={"logo"} />
            </Link>
            {isLoggedIn && (
                <div className={"items-center flex gap-4"}>
                    <p className={"text-md "}>Nguyễn Văn A</p>
                    <Link to={config.routes.profile} onClick={onClose}>
                        <img className={"w-8 h-8 rounded-full"} src={config.webConfig.defaultAvatar} alt={"avatar"} />
                    </Link>
                </div>
            )}
        </div>
    )
    return (
        <>
            <Button
                onClick={showDrawer}
                className=" px-4 py-2 rounded-md bg-transparent border-primary text-primary"
            >
                <MenuFoldOutlined/>
            </Button>
            <Drawer title={MenuHeader} placement="right" onClose={onClose} open={open}>
                <ul className="space-y-4">
                    {liItems.map((item, index) => (
                        <li key={index}>
                            <Link to={item.src} onClick={onClose} className="text-lg text-gray-500 hover:text-gray-700">
                                {item.title}
                            </Link>
                        </li>
                    ))}
                </ul>
            </Drawer>
        </>
    );
};

export default DrawerMB;
